import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { ROUTES } from 'config/routes';
import { OperationMessage } from 'components/presentational/application/OperationMessage';

export interface IProtectedRouteProps extends RouteProps {
	currentPath: string
	component: any;
	isHasSubscription: boolean;
	isPendingEmail: boolean;
	isAuthenticated: boolean;
	isUserLoaded: boolean;
}

/* Ensures User Can Access The Portal Internal Pages */
const ProtectedRouteComponent: React.SFC<IProtectedRouteProps> = (props) => {
	const { component: Component, isAuthenticated, isHasSubscription, isPendingEmail, isUserLoaded, ...rest } = props
	let renderComponent = (childProps) => <Redirect to={ROUTES.LANDING} />;
	if (isAuthenticated) {
		if (isUserLoaded === false) {
			renderComponent = () => <OperationMessage message="Loading..." />;
		} else if (isPendingEmail === true && props.currentPath !== ROUTES.EMAIL_PENDING) {
			renderComponent = () => <Redirect to={ROUTES.EMAIL_PENDING} />;
		} else if (isPendingEmail === false && isHasSubscription === false && props.currentPath !== ROUTES.SUBSCRIBE) {
			renderComponent = () => <Redirect to={ROUTES.SUBSCRIBE} />;
		} else if (isPendingEmail === false && isHasSubscription === true && (props.currentPath === ROUTES.SUBSCRIBE || props.currentPath === ROUTES.EMAIL_PENDING)) {
			renderComponent = () => <Redirect to={ROUTES.HOME} />;
		} else {
			renderComponent = (childProps) => <Component {...childProps} />;
		}
	}
	return <Route {...rest} render={renderComponent} />
}

export const ProtectedRoute = ProtectedRouteComponent


// WEBPACK FOOTER //
// ./src/components/containers/ProtectedRoute.tsx